/* ── StatusBadge ─────────────────────────────────────────────
   StatusBadge.jsx
   ─────────────────────────────────────────────────────────── */
const BADGE = {
  submitted:   { label: 'Submitted',   color: '#16A34A', bg: '#DCFCE7' },
  in_progress: { label: 'In Progress', color: '#A16207', bg: '#FEF9C3' },
  data_loaded: { label: 'Data Loaded', color: '#1D4ED8', bg: '#EFF6FF' },
  pending:     { label: 'Pending',     color: '#9CA3AF', bg: '#F3F4F6' },
  acknowledged:{ label: 'Acknowledged',color: '#6B7280', bg: '#F3F4F6' },
};

export default function StatusBadge({ status }) {
  const cfg = BADGE[status] || { label: status, color: '#6B7280', bg: '#F3F4F6' };
  return (
    <span style={{
      fontSize: '10px', fontWeight: 600, padding: '2px 8px', borderRadius: '10px',
      background: cfg.bg, color: cfg.color, textTransform: 'capitalize',
    }}>
      {cfg.label}
    </span>
  );
}
